import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import methodModel from "../../../methods/methods";
import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import Sidebar from "../sidebar";
import { FiMenu, FiX } from "react-icons/fi";
import { LuLogOut, LuUser } from "react-icons/lu";
import { GoLock } from "react-icons/go";
import { FaArrowDown, FaChevronDown } from "react-icons/fa";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Html = ({ isOpen, toggle, user, isOpen1, Logout }) => {

  const history = useNavigate();
  // useEffect(() => {
  //   window.googleTranslateElementInit = () => {
  //     console.log("Callback: googleTranslateElementInit");
  //     try {
  //       new window.google.translate.TranslateElement(
  //         {
  //           pageLanguage: "en",
  //           includedLanguages: "en,ja",
  //         },
  //         "google_translate_element"
  //       );
  //       setTimeout(() => {
  //         const select = document.querySelector(".goog-te-combo");
  //         if (select) {
  //           select.value = "en";
  //           select.dispatchEvent(new Event("change"));
  //           console.log("Defaulted to English");
  //         }
  //       }, 1000);
  //     } catch (e) {
  //       console.error("Translate Element failed to initialize", e);
  //     }
  //   };
  //   if (!document.getElementById("google_translate_script")) {
  //     const script = document.createElement("script");
  //     script.id = "google_translate_script";
  //     script.src =
  //       "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
  //     script.async = true;
  //     document.body.appendChild(script);
  //   }
  // }, []);
  useEffect(() => {
    const loadGoogleTranslateScript = () => {
      if (!document.getElementById("google_translate_script")) {
        const addScript = document.createElement("script");
        addScript.id = "google_translate_script";
        addScript.type = "text/javascript";
        addScript.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";

        addScript.onerror = (err) => {
          console.error("Google Translate script failed to load", err);
        };

        document.body.appendChild(addScript);
      }

      window.googleTranslateElementInit = () => {
        try {
          new window.google.translate.TranslateElement(
            { pageLanguage: "en", includedLanguages: "en,ja" },
            "google_translate_element"
          );
        } catch (e) {
          console.error("Translate Element failed to initialize", e);
        }
      };
    };

    const elementContainer = document.getElementById("google_translate_element");
    if (!elementContainer || elementContainer.innerHTML.trim() === "") {
      loadGoogleTranslateScript();
    }
    
  }, []);
  useEffect(() => {
    if (user?.role === "admin") return;
    const location = window.location.pathname;
    const userPermissions = user?.permissions?.[0] || {};
    const routePermissionMap = {
      "/dashboard": "readDashboard",
      "/location": "readLocation",
      "/manager": "readManager",
      "/staff": "readStaff",
      "/performance": "readperformance",
      "/store": "readstore",
      "/supplier": "readsupplier",
    };
    const basePath = `/${location.split("/")[1]}`;
    const requiredPermission = routePermissionMap[basePath];
    if (requiredPermission && !userPermissions[requiredPermission]) {
      history("/profile"); 
    }
  }, [user, history]);

  return (
    <nav
      component="header"
      className={`${
        isOpen ? "min-sidebar w-[calc(100%-80px)]" : "w-[calc(100%-280px)] "
      } shadow-btn py-1.5 bg-[#f8f9fa] border-b  fixed transition-[width] duration-300 ml-auto right-0 z-10 flex items-center !px-2 sm:!px-5
      `}
    >
      <div id="logoutBtn" onClick={() => Logout()}></div>
      <button
        onClick={toggle}
        className="h-9 w-9 shrink-0 shadow-btn hover:shadow-none p-1 rounded-lg border border-gray-100 !text-primary"
      >
        {!isOpen ? (
          <FiMenu className="w-full h-full" />
        ) : (
          <FiX className="w-full h-full" />
        )}
      </button>

      <div className="flex items-center gap-2 sm:gap-4 ml-auto">
        <div id="google_translate_element"></div>

        <Menu as="div" className="relative">
          <div>
            <Menu.Button className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-1 sm:px-3 py-1 text-sm font-semibold text-gray-900 ">
              <div className="flex items-center gap-2">
                <div className="flex items-center">
                  <img
                    alt="image"
                    src={methodModel.userImg(user.image)}
                    className="h-[48px] w-[48px] min-h-[48px] min-w-[48px] rounded-full object-cover"
                  />
                  <div className="ml-2 text-left hidden md:block">
                    <span className="capitalize">{user.fullName}</span>
                    <p className="grayCls capitalize mb-0 text-capitalize">
                      {user.role}
                    </p>
                  </div>
                </div>
                <FaChevronDown />
                {/* <i
                  className="fa fa-angle-down top-1 relative h-5 w-5 text-gray-400"
                  aria-hidden="true"
                /> */}
              </div>
            </Menu.Button>
          </div>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
              <div className="py-1">
                <Menu.Item>
                  {({ active }) => (
                    <Link
                      to="/profile"
                      className={classNames(
                        active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                        "block px-4 py-2 text-sm flex items-center gap-2"
                      )}
                    >
                      <LuUser /> Profile
                    </Link>
                  )}
                </Menu.Item>
                {/* <Menu.Item>
                  {({ active }) => (
                    <Link
                      to="/dashboard"
                      className={classNames(
                        active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                        "block px-4 py-2 text-sm flex align-center flex items-center gap-2"
                      )}
                    >
                      <RxDashboard /> Dashboard
                    </Link>
                  )}
                </Menu.Item> */}
                <Menu.Item>
                  {({ active }) => (
                    <Link
                      to="/profile/change-password"
                      className={classNames(
                        active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                        "block px-4 py-2 text-sm flex items-center gap-2"
                      )}
                    >
                      <GoLock />
                      Change Password
                    </Link>
                  )}
                </Menu.Item>

                <Menu.Item className="divide-y-1 divide-gray-800 pt-1  mt-2">
                  <p className="border-t"></p>
                </Menu.Item>

                <Menu.Item className="">
                  {({ active }) => (
                    <span
                      onClick={() => Logout()}
                      className={classNames(
                        active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                        "block w-full px-4 py-2 text-left text-sm ancortag flex items-center gap-2 cursor-pointer"
                      )}
                    >
                      <LuLogOut /> Logout
                    </span>
                  )}
                </Menu.Item>
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
      </div>
      {isOpen1 ? (
        <div className="w-100 mobi-dropdown">
          <Sidebar />
        </div>
      ) : (
        <></>
      )}
    </nav>
  );
};

export default Html;
